<template>
  <span>{{ echoDateTime(value, 'datetime') }}</span>
</template>

<script>
import FieldViewer from '@/components/fields/FieldViewer'

export default {
  name: 'FieldViewerDateTime',
  extends: FieldViewer,
}
</script>
